/*
 * Mono Editorial 디자인용 프로젝트 데이터.
 * 참고 형식: 기간(1차/2차), 문단 설명, 기술 칩, 역할 불릿, 스크린샷 캐러셀.
 * carousel 이미지 출처:
 *  - algorithm/forde: 팀원(김승용) 포트폴리오에서 허락받아 재사용
 *  - globa: 본인 저장소 스크린샷
 */
export const projects = [
  {
    id: "aivo",
    title: "aivo",
    featured: true,
    badges: [
      { text: "주요 프로젝트", tone: "accent" },
      { text: "서비스 중", tone: "green" },
    ],
    periods: [{ label: "개발 기간", value: "2026.07 - 2026.08" }],
    paragraphs: [
      "발표와 면접 연습을 혼자서도 객관적으로 점검할 수 있게 도와주는 AI 코칭 서비스입니다.",
      "웹캠과 마이크만으로 연습을 녹화하면 음성·시선·자세·발화 내용을 분석해 구간별 리포트로 돌려주고, 발화 속도(WPM)·추임새·무음 구간 같은 지표를 수치로 제공합니다.",
    ],
    metrics: [
      { value: "기술 리더", label: "전반 개발 주도" },
      { value: "준실시간", label: "오디오 청크 분석" },
      { value: "AI 서버", label: "개발 · 배포 전담" },
    ],
    tags: [
      "Spring Boot",
      "Spring AI",
      "Spring Data JPA",
      "PostgreSQL",
      "RabbitMQ",
      "FastAPI",
      "Redis",
      "AWS S3",
      "Git / GitHub",
    ],
    roles: [
      "면접 도메인 전반(질문 생성 → 녹화 → 분석 → 리포트) 백엔드 설계 및 구현",
      "직무 / 자기소개서 / 포트폴리오 / 기업 정보를 조합한 LLM 면접 질문 생성 개발",
      "네이버 검색 API 기반 기업 조사 및 조사 결과 캐싱(7일) 구조 설계",
      "LLM 응답 JSON Schema 강제 및 파싱 실패 방어로 리포트 생성 안정화",
      "RabbitMQ 기반 면접 리포트 비동기 처리 및 Job 상태 폴링 API 개발",
      "FastAPI AI 서버(faster-whisper + silero-vad)와의 STT / 음성 분석 연동",
      "녹화 중 준실시간 오디오 청크 분석 파이프라인 구성",
      "Apache POI / PDFBox 기반 발표 자료 파싱 및 미인식 케이스 방어 처리",
      "배포 환경 구성 및 포팅 매뉴얼(빌드·배포, 외부 서비스, DB) 작성",
    ],
    embed: {
      url: "https://ssafy-pjt-presentation-source.vercel.app/",
      title: "aivo 발표 자료",
    },
    website: "https://aivo.ai.kr",
    github: null,
  },
  {
    id: "globa",
    title: "Globa",
    featured: true,
    badges: [
      { text: "주요 프로젝트", tone: "accent" },
      { text: "학과 최우수작", tone: "gold" },
    ],
    periods: [
      { label: "1차 개발", value: "2024.03 - 2024.09" },
      { label: "2차 개발", value: "2025.01 - 2025.09" },
    ],
    paragraphs: [
      "강의나 회의처럼 길게 녹음한 음성을 텍스트로 변환하고, 요약·퀴즈·섹션 분리 기능까지 제공하는 AI 기반 음성 분석 모바일 애플리케이션입니다.",
      "2024 소프트웨어공학과 졸업작품전에서 학과 최우수작으로 선정되어 대표 발표를 진행했습니다.",
    ],
    metrics: [
      { value: "0.6 → 0.3", label: "WER / CER 성능 개선" },
      { value: "영어 · 일본어", label: "STT 다국어화" },
      { value: "AWS SQS", label: "비동기 처리 구조" },
    ],
    tags: [
      "Spring Boot",
      "Spring Data JPA",
      "Python",
      "Whisper",
      "MySQL",
      "Redis",
      "AWS EC2",
      "AWS RDS",
      "AWS SQS",
      "Docker",
      "Git / GitHub",
    ],
    roles: [
      "DB 설계 및 구축, API 데이터 처리 로직 구현",
      "Whisper 기반 영어 / 일본어 STT 기능 구현",
      "WER / CER 기준 STT 정확도 0.6 → 0.3 수준으로 개선",
      "TextBlob, MeCab을 활용한 영어 / 일본어 형태소 추출 기능 구현",
      "AWS SQS 기반 비동기 처리 구조 적용",
      "Vast.ai + Docker 기반 AI 서버 분리 운영",
      "AI 서버와 서비스 서버 간 연동 구조 구현",
    ],
    youtube: { id: "NHepQN2UuM8", title: "Globa 시연 영상" },
    github: "https://github.com/Globa-Seoil-Univ/globa-backend",
  },
  {
    id: "perfectfit",
    title: "PerfectFit",
    featured: false,
    badges: [],
    periods: [{ label: "개발 기간", value: "2024.09 - 2024.12" }],
    paragraphs: [
      "사용자의 경험, 희망 직무, 입력 정보를 기반으로 자기소개서와 AI 모의면접 콘텐츠를 생성하는 웹 서비스입니다.",
      "맞춤법 검사, 공개 / 비공개 설정, 좋아요 / 조회수, 직무 기반 면접 생성까지 취업 준비 흐름을 하나의 서비스로 연결했습니다.",
    ],
    metrics: [
      { value: "Celery + Redis", label: "AI 생성 비동기 처리" },
      { value: "면접 시스템", label: "설계 · API 개발 담당" },
      { value: "팀장", label: "담당 역할" },
    ],
    tags: ["Flask", "Python", "OpenAI / GPT", "Celery", "MariaDB", "Redis", "Git / GitHub"],
    roles: [
      "팀장으로서 일정 조율 및 기능 우선순위 관리",
      "DB 설계",
      "면접 시스템 구축 및 관련 API 개발",
      "사용자 정보 입력 / 수정 및 면접 관련 기능 개발",
      "Celery + Redis 기반 AI 생성 작업 비동기 처리",
      "JWT Refresh Token 관리에 Redis 적용",
    ],
    images: [
      "/images/projects/perfectfit/carousel/01.gif",
      "/images/projects/perfectfit/carousel/02.gif",
      "/images/projects/perfectfit/carousel/03.gif",
      "/images/projects/perfectfit/carousel/04.gif",
      "/images/projects/perfectfit/carousel/05.gif",
      "/images/projects/perfectfit/carousel/06.gif",
      "/images/projects/perfectfit/carousel/07.gif",
      "/images/projects/perfectfit/carousel/08.gif",
    ],
    github: "https://github.com/7-wonders/PerfectFit",
  },
  {
    id: "forde",
    title: "FORDE",
    featured: false,
    badges: [],
    periods: [{ label: "개발 기간", value: "2025.02 - 2025.04" }],
    paragraphs: [
      "IT 업계 선배, 후배, 동기들의 다양한 경험과 조언을 공유하는 커뮤니티 웹사이트입니다.",
      "게시글, 댓글, 좋아요, 알림, 개인화 피드 등 커뮤니티 서비스의 주요 흐름을 실제로 구현하는 데 초점을 맞췄습니다.",
    ],
    metrics: [
      { value: "Recoil", label: "전역 상태 관리" },
      { value: "SSE", label: "실시간 알림 연동" },
      { value: "무한 스크롤", label: "목록 UI 처리" },
    ],
    tags: [
      "React",
      "TypeScript",
      "Recoil",
      "Spring Boot",
      "MariaDB",
      "Redis",
      "Git / GitHub",
    ],
    roles: [
      "React / TypeScript 기반 프론트엔드 구축",
      "Recoil 기반 전역 상태 관리 구조 설계",
      "게시글 목록 / 상세 / 댓글 / 대댓글 UI 연동",
      "무한 스크롤 및 페이지네이션 UI 구현",
      "SSE 기반 실시간 알림 UI 연동",
      "백엔드 REST API 연동 및 에러 / 로딩 상태 처리",
    ],
    images: [
      "/images/projects/forde/carousel/02.png",
      "/images/projects/forde/carousel/03.png",
      "/images/projects/forde/carousel/04.png",
      "/images/projects/forde/carousel/05.png",
      "/images/projects/forde/carousel/06.png",
      "/images/projects/forde/carousel/07.png",
      "/images/projects/forde/carousel/08.png",
      "/images/projects/forde/carousel/09.png",
      "/images/projects/forde/carousel/10.png",
      "/images/projects/forde/carousel/11.png",
      "/images/projects/forde/carousel/12.png",
      "/images/projects/forde/carousel/13.png",
    ],
    github: "https://github.com/3-Wonders/Forde-Front",
  },
  {
    id: "algorithm",
    title: "Algorithm",
    featured: false,
    badges: [],
    periods: [
      { label: "1차 개발", value: "2024.01 - 2024.02" },
      { label: "2차 개발", value: "2024.07 - 2024.09" },
    ],
    paragraphs: [
      "다양한 알고리즘 문제를 풀고 실력을 향상시킬 수 있는 웹 애플리케이션입니다.",
      "백준·프로그래머스와 차별점을 두기 위해 문제 해설과 질문 게시판을 제공합니다.",
    ],
    metrics: [
      { value: "ProcessBuilder", label: "코드 실행 환경" },
      { value: "Redis", label: "세션 관리" },
      { value: "SSR", label: "Next.js 렌더링 구조" },
    ],
    tags: ["Spring", "MySQL", "Redis", "JPA", "Git / GitHub"],
    roles: [
      "DB 및 API 설계, 백엔드 전반 개발",
      "알고리즘 문제 / 해설 / 질문 게시판 구축",
      "ProcessBuilder 기반 코드 실행 환경 구성",
      "Redis 기반 세션 관리",
    ],
    images: [
      "/images/projects/algorithm/carousel/01.png",
      "/images/projects/algorithm/carousel/02.png",
      "/images/projects/algorithm/carousel/03.png",
      "/images/projects/algorithm/carousel/05.png",
      "/images/projects/algorithm/carousel/06.png",
      "/images/projects/algorithm/carousel/07.png",
      "/images/projects/algorithm/carousel/08.png",
      "/images/projects/algorithm/carousel/09.png",
      "/images/projects/algorithm/carousel/10.png",
      "/images/projects/algorithm/carousel/11.png",
      "/images/projects/algorithm/carousel/12.png",
      "/images/projects/algorithm/carousel/13.png",
      "/images/projects/algorithm/carousel/14.png",
    ],
    github: "https://github.com/Seoil-Twins/algorithm",
  },
  {
    id: "ysy",
    title: "YSY",
    featured: false,
    badges: [],
    periods: [{ label: "개발 기간", value: "2023.01 - 2023.11" }],
    paragraphs: [
      "커플 간의 일정, 앨범 등을 공유하여 손쉽게 추억을 쌓고 관리할 수 있는 모바일 애플리케이션입니다.",
      "React Native, Node.js, TypeScript를 학습하고 적용해 데이트 장소 추천까지 제공하는 앱으로 완성했습니다.",
    ],
    metrics: [
      { value: "기획", label: "전체 서비스 구성" },
      { value: "React Native", label: "프론트 화면 구성" },
      { value: "API 연결", label: "SNS 로그인 · 앨범 · 일정" },
    ],
    tags: [
      "React Native",
      "TypeScript",
      "Node.js",
      "Express",
      "Sequelize",
      "MySQL",
      "Redis",
      "GCS",
      "Adobe XD",
    ],
    roles: [
      "전체적인 기획 구성",
      "React Native 기반 프론트 디자인 구성",
      "SNS 로그인(카카오 / 네이버 / 구글), 앨범, 일정 등 화면과 백엔드 API 연결",
    ],
    images: [
      "/images/projects/ysy/carousel/01.jpg",
      "/images/projects/ysy/carousel/02.jpg",
      "/images/projects/ysy/carousel/03.jpg",
      "/images/projects/ysy/carousel/04.jpg",
      "/images/projects/ysy/carousel/05.jpg",
      "/images/projects/ysy/carousel/06.jpg",
      "/images/projects/ysy/carousel/07.jpg",
      "/images/projects/ysy/carousel/08.jpg",
      "/images/projects/ysy/carousel/09.jpg",
      "/images/projects/ysy/carousel/10.jpg",
    ],
    imageFit: "contain",
    github: "https://github.com/Seoil-Twins/ysy",
  },
  {
    id: "codemong",
    title: "CodeMong",
    featured: true,
    defaultOpen: false,
    badges: [{ text: "주요 프로젝트", tone: "accent" }],
    periods: [{ label: "개발 기간", value: "2026.04 - 2026.06" }],
    paragraphs: [
      "GitHub 기반 단계별 프로젝트 학습 및 AI 코드 피드백 플랫폼입니다.",
      "프로젝트와 Step을 선택하면 Branch 생성과 Starter Code 세팅이 자동으로 이루어지고, 제출한 코드는 Hidden Test로 검사합니다.",
    ],
    metrics: [
      { value: "GitHub Actions", label: "자동 코드 검사" },
      { value: "Self-hosted", label: "Runner 직접 운영" },
      { value: "배포 전반", label: "EC2 · RDS · Nginx" },
    ],
    tags: [
      "Vue",
      "Spring Boot",
      "PostgreSQL",
      "Redis",
      "GitHub API",
      "GitHub Actions",
      "AWS EC2 / RDS",
      "Nginx",
    ],
    roles: [
      "팀장으로서 기획 / 설계 주도",
      "프로젝트 / Step 선택에 따른 Branch 생성 및 Starter Code 세팅 기능 구현",
      "GitHub Actions + Self-hosted Runner 기반 Hidden Test 코드 검사 시스템 구축",
      "AWS EC2, RDS, Nginx, systemd 기반 백엔드 배포 및 운영 환경 구성",
    ],
    images: [
      "/images/projects/codemong/carousel/01.jpg",
      "/images/projects/codemong/carousel/02.jpg",
      "/images/projects/codemong/carousel/03.jpg",
      "/images/projects/codemong/carousel/04.jpg",
      "/images/projects/codemong/carousel/05.jpg",
      "/images/projects/codemong/carousel/06.jpg",
      "/images/projects/codemong/carousel/07.jpg",
    ],
    website: "https://www.codemong.com",
    github: "https://github.com/SSFAY-CodeMong/codemong-be",
  },
];

export default projects;
